
import moment from "moment-timezone";

moment.tz.setDefault("Asia/Bahrain");

export default moment;
